import { PROFILE_ROUTES } from './routesByGroups/profile';
import { DASHBOARD_ROUTES } from './routesByGroups/dashboard';
import { BHI_ROUTES } from './routesByGroups/bhi';
import { ALERT_ROUTES } from './routesByGroups/alert';
import { ACCOUNT_ROUTES } from './routesByGroups/account';
import { USER_ROUTES } from './routesByGroups/user';
import { PATIENT_ROUTES } from './routesByGroups/patient';
import { ORDER_ROUTES } from './routesByGroups/order';
import { ASSESSMENT_ROUTES } from './routesByGroups/assessment';
import { RESOURCE_ROUTES } from './routesByGroups/resource';
import { CLAIM_ROUTES } from './routesByGroups/claim';
import { CLAIM_REPORT_ROUTES } from './routesByGroups/claimReport';
import { REPORTABLE_ROUTES } from './routesByGroups/reportable';
import { BOT_ACTIVITY_ROUTES } from './routesByGroups/botActivity';
import { PROGRAM_ROUTES } from './routesByGroups/program';
import { ALLERGI_END_RESOURCES_ROUTES } from './routesByGroups/allergiEndResources';
import { QHSLAB_DOCUMENTS_ROUTES } from './routesByGroups/qhslabDocuments';
import { RESOURCE_CENTER_ROUTES } from './routesByGroups/resourceCenter';
import { PROVIDER_ROUTES } from './routesByGroups/provider';
import { JOURNEY_ROUTES } from './routesByGroups/journey';
import { OAUTH_ROUTES } from './routesByGroups/oauth';
import { PERMISSIONS_TESTING_ROUTES } from './routesByGroups/permissionsTesting';

export const PRIVATE_ROUTES = {
  profile: PROFILE_ROUTES,
  dashboard: DASHBOARD_ROUTES,
  bhiDashboard: BHI_ROUTES,
  alert: ALERT_ROUTES,
  account: ACCOUNT_ROUTES,
  user: USER_ROUTES,
  patient: PATIENT_ROUTES,
  order: ORDER_ROUTES,
  assessment: ASSESSMENT_ROUTES,
  resource: RESOURCE_ROUTES,
  claim: CLAIM_ROUTES,
  claimReport: CLAIM_REPORT_ROUTES,
  reportable: REPORTABLE_ROUTES,
  botActivity: BOT_ACTIVITY_ROUTES,
  program: PROGRAM_ROUTES,
  allergiEndResources: ALLERGI_END_RESOURCES_ROUTES,
  qhslabDocuments: QHSLAB_DOCUMENTS_ROUTES,
  resourceCenter: RESOURCE_CENTER_ROUTES,
  provider: PROVIDER_ROUTES,
  oauth: OAUTH_ROUTES,
  journey: JOURNEY_ROUTES,
  permissionsTesting: PERMISSIONS_TESTING_ROUTES,
};
